import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const R = 22;
const CIRC = 2 * Math.PI * R;

export const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const y = window.scrollY;
      setProgress(scrollable > 0 ? Math.min(1, y / scrollable) : 0);
      setVisible(y > 400);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); };
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Scroll to top"
      data-testid="scroll-to-top-btn"
      className={`fixed bottom-6 right-6 z-[60] h-[52px] w-[52px] rounded-full bg-[#12234A] text-white shadow-lg
        flex items-center justify-center transition-all duration-300 hover:bg-[#1b3366] hover:-translate-y-0.5
        focus:outline-none focus:ring-2 focus:ring-[#F5551E]/50
        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <svg className="absolute inset-0 -rotate-90" width="52" height="52" viewBox="0 0 52 52" aria-hidden="true">
        <circle cx="26" cy="26" r={R} fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="3" />
        <circle
          cx="26" cy="26" r={R} fill="none" stroke="#F5551E" strokeWidth="3" strokeLinecap="round"
          strokeDasharray={CIRC}
          strokeDashoffset={CIRC * (1 - progress)}
          style={{ transition: "stroke-dashoffset 0.1s linear" }}
          data-testid="scroll-progress-ring"
        />
      </svg>
      <ArrowUp size={20} className="relative z-10" />
    </button>
  );
};
